import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'pa',
    fullName: 'Punjabi',
    nativeName: 'ਪੰਜਾਬੀ',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "ਕੁਝ ਹੈਰਾਨੀਜਨਕ ਆ ਰਿਹਾ ਹੈ",
    landing_subtitle: "ArgVoid ਇੱਕ ਐਪ ਅਤੇ ਗੇਮ ਡਿਵੈਲਪਮੈਂਟ ਸਟੂਡੀਓ ਹੈ। ਜੁੜੇ ਰਹੋ, ਨਵੀਆਂ ਚੀਜ਼ਾਂ ਜਲਦੀ ਆ ਰਹੀਆਂ ਹਨ!",
    select_language: "ਭਾਸ਼ਾ ਚੁਣੋ",
    search_placeholder: "ਭਾਸ਼ਾਵਾਂ ਖੋਜੋ...",
    terms_title: "ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ",
    policy_title: "ਪਰਾਈਵੇਟ ਨੀਤੀ",
    cookies_title: "ਕੂਕੀ ਨੀਤੀ",
    terms_content: `
        <strong>1. ਸ਼ਰਤਾਂ ਦੀ ਸਵੀਕ੍ਰਿਤੀ</strong><br>
        ArgVoid ਤੱਕ ਪਹੁੰਚ ਕਰਕੇ, ਇਹ ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ ਸਵੀਕਾਰ ਕੀਤੀਆਂ ਜਾਂਦੀਆਂ ਹਨ। ਜੇਕਰ ਇਹਨਾਂ ਸ਼ਰਤਾਂ ਨਾਲ ਸਹਿਮਤ ਨਹੀਂ ਹੁੰਦੇ, ਤਾਂ ਸੇਵਾ ਦੀ ਵਰਤੋਂ ਨਹੀਂ ਕੀਤੀ ਜਾਣੀ ਚਾਹੀਦੀ।<br><br>

        <strong>2। ਪਲੇਟਫਾਰਮ ਵਰਤੋਂ</strong><br>
        ArgVoid ਅਤੇ ਇਸਦੀਆਂ ਐਪਲੀਕੇਸ਼ਨਾਂ ਨੂੰ ਜਾਣਕਾਰੀ ਅਤੇ ਰਚਨਾਤਮਕ ਉਦੇਸ਼ਾਂ ਲਈ "ਜਿਵੇਂ ਹੈ" ਪ੍ਰਦਾਨ ਕੀਤਾ ਜਾਂਦਾ ਹੈ। ਸੇਵਾ ਦੀ ਵਰਤੋਂ ਸਿਰਫ਼ ਕਨੂੰਨੀ ਉਦੇਸ਼ਾਂ ਲਈ ਕੀਤੀ ਜਾਣੀ ਚਾਹੀਦੀ ਹੈ।<br><br>

        <strong>3। ਵਰਜਿਤ ਆਚਰਣ</strong><br>
        ਸਾਈਟ ਦੀਆਂ ਕਮਜ਼ੋਰੀਆਂ ਦਾ ਸ਼ੋਸ਼ਣ ਕਰਨਾ, ਸਪੈਮਿੰਗ ਕਰਨਾ, ਜਾਂ ਬੁਨਿਆਦੀ ਢਾਂਚੇ ਤੱਕ ਅਣਅਧਿਕਾਰਤ ਪਹੁੰਚ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰਨਾ ਸਖਤੀ ਨਾਲ ਵਰਜਿਤ ਹੈ।<br><br>

        <strong>4। ਬੇਦਾਅਵਾ</strong><br>
        ਪਲੇਟਫਾਰਮ ਅਤੇ ਸੇਵਾਵਾਂ ਨੂੰ ਬਿਨਾਂ ਨੋਟਿਸ ਦੇ ਕਿਸੇ ਵੀ ਸਮੇਂ ਸੋਧਿਆ ਜਾ ਸਕਦਾ ਹੈ। ਸੇਵਾ ਦੇ ਅਪਟਾਈਮ ਜਾਂ ਉਪਲਬਧਤਾ ਦੇ ਸਬੰਧ ਵਿੱਚ ਕੋਈ ਵਾਰੰਟੀ ਨਹੀਂ ਦਿੱਤੀ ਗਈ ਹੈ।
    `,
    policy_content: `
        <strong>1. ਜਾਣਕਾਰੀ ਸੰਗ੍ਰਹਿ</strong><br>
        ਪਲੇਟਫਾਰਮ ਨੂੰ ਇਸ ਸਮੇਂ ਉਪਭੋਗਤਾ ਪ੍ਰਮਾਣੀਕਰਨ ਜਾਂ ਖਾਤਾ ਬਣਾਉਣ ਦੀ ਲੋੜ ਨਹੀਂ ਹੈ। ਕੋਈ ਵੀ ਨਿੱਜੀ ਪਛਾਣ ਜਾਣਕਾਰੀ (ਜਿਵੇਂ ਕਿ ਨਾਮ ਜਾਂ ਈਮੇਲ ਪਤੇ) ਦਰਸ਼ਕਾਂ ਤੋਂ ਸਰਗਰਮੀ ਨਾਲ ਇਕੱਤਰ ਨਹੀਂ ਕੀਤੀ ਜਾਂਦੀ।<br><br>

        <strong>2। ਵਰਤੋਂ ਡੇਟਾ</strong><br>
        ਸਾਈਟ ਟ੍ਰੈਫਿਕ ਨੂੰ ਸਮਝਣ ਅਤੇ ਐਪਲੀਕੇਸ਼ਨਾਂ ਨੂੰ ਬਿਹਤਰ ਬਣਾਉਣ ਲਈ ਬੁਨਿਆਦੀ, ਅਗਿਆਤ ਵਿਸ਼ਲੇਸ਼ਣ ਇਕੱਠੇ ਕੀਤੇ ਜਾ ਸਕਦੇ ਹਨ। ਇਹ ਡੇਟਾ ਵਿਅਕਤੀਗਤ ਉਪਭੋਗਤਾ ਪਛਾਣਾਂ ਨਾਲ ਲਿੰਕ ਨਹੀਂ ਹੈ।<br><br>

        <strong>3। ਤੀਜੀ-ਧਿਰ ਦੀਆਂ ਸੇਵਾਵਾਂ</strong><br>
        ਹੋਸਟਿੰਗ ਅਤੇ ਵਿਸ਼ਲੇਸ਼ਣ ਸੇਵਾਵਾਂ ਲਈ ਤੀਜੀ-ਧਿਰ ਪ੍ਰਦਾਤਾਵਾਂ ਦੀ ਵਰਤੋਂ ਕੀਤੀ ਜਾ ਸਕਦੀ ਹੈ। ਇਹਨਾਂ ਸੰਬੰਧਿਤ ਪ੍ਰਦਾਤਾਵਾਂ ਦੇ ਗੋਪਨੀਯਤਾ ਅਭਿਆਸ ਉਹਨਾਂ ਦੇ ਬੁਨਿਆਦੀ ਢਾਂਚੇ 'ਤੇ ਪ੍ਰਕਿਰਿਆ ਕੀਤੇ ਗਏ ਅਗਿਆਤ ਡੇਟਾ ਨੂੰ ਨਿਯੰਤ੍ਰਿਤ ਕਰਦੇ ਹਨ।<br><br>

        <strong>4। ਡਾਟਾ ਸੁਰੱਖਿਆ</strong><br>
        ਪਲੇਟਫਾਰਮ ਦੀ ਸੁਰੱਖਿਆ ਲਈ ਵਾਜਬ ਸੁਰੱਖਿਆ ਉਪਾਅ ਲਾਗੂ ਕੀਤੇ ਜਾਂਦੇ ਹਨ। ਹਾਲਾਂਕਿ, ਇੰਟਰਨੈੱਟ 'ਤੇ ਪ੍ਰਸਾਰਣ ਦਾ ਕੋਈ ਤਰੀਕਾ ਪੂਰੀ ਤਰ੍ਹਾਂ ਸੁਰੱਖਿਅਤ ਨਹੀਂ ਹੈ।<br><br>
    `,
    cookies_content: `
        <strong>1. ਕੂਕੀਜ਼ ਅਤੇ ਲੋਕਲ ਸਟੋਰੇਜ ਕੀ ਹਨ?</strong><br>
        ਕੂਕੀਜ਼ ਅਤੇ ਬ੍ਰਾਊਜ਼ਰ ਲੋਕਲ ਸਟੋਰੇਜ ਛੋਟੀਆਂ ਡਾਟਾ ਫਾਈਲਾਂ ਹਨ ਜੋ ਡਿਵਾਈਸ 'ਤੇ ਸਟੋਰ ਕੀਤੀਆਂ ਜਾਂਦੀਆਂ ਹਨ ਤਾਂ ਜੋ ਵਿਜ਼ਿਟਾਂ ਦੌਰਾਨ ਸੰਰਚਨਾ ਤਰਜੀਹਾਂ ਨੂੰ ਯਾਦ ਰੱਖਿਆ ਜਾ ਸਕੇ।<br><br>

        <strong>2। ਵਰਤੋਂ ਦਾ ਮਕਸਦ</strong><br>
        ਬ੍ਰਾਊਜ਼ਰ ਲੋਕਲ ਸਟੋਰੇਜ ਦੀ ਵਰਤੋਂ ਕੌਂਫਿਗਰੇਸ਼ਨ ਸੈਟਿੰਗਾਂ ਨੂੰ ਸੁਰੱਖਿਅਤ ਕਰਨ ਲਈ ਕੀਤੀ ਜਾਂਦੀ ਹੈ, ਜਿਵੇਂ ਕਿ:<br>
        - ਭਾਸ਼ਾ ਤਰਜੀਹਾਂ<br>
        - ਯੂਜ਼ਰ ਇੰਟਰਫੇਸ ਕੌਂਫਿਗਰੇਸ਼ਨ (ਉਦਾਹਰਨ ਲਈ, ਲੇਆਉਟ ਜਾਂ ਥੀਮ ਸੈਟਿੰਗ) <br>
        - ਅਸਥਾਈ ਐਪਲੀਕੇਸ਼ਨ cache<br><br>

        <strong>3। ਕੋਈ Tracking</strong><br> ਨਹੀਂ
        ਕੂਕੀਜ਼ ਅਤੇ ਸਥਾਨਕ ਸਟੋਰੇਜ ਦੀ ਵਰਤੋਂ ਇਸ਼ਤਿਹਾਰਬਾਜ਼ੀ ਜਾਂ ਤੀਜੀ-ਧਿਰ ਦੇ ਟਰੈਕਿੰਗ ਉਦੇਸ਼ਾਂ ਲਈ ਨਹੀਂ ਕੀਤੀ ਜਾਂਦੀ। ਸਾਰਾ ਸਟੋਰ ਕੀਤਾ ਡਾਟਾ ਪਲੇਟਫਾਰਮ ਦੀ ਮੁੱਖ ਕਾਰਜਕੁਸ਼ਲਤਾ ਲਈ ਸਖਤੀ ਨਾਲ ਹੈ।<br><br>

        <strong>4। Control</strong><br>
        ਬ੍ਰਾਊਜ਼ਰ ਡੇਟਾ ਨੂੰ ਕਿਸੇ ਵੀ ਸਮੇਂ ਬ੍ਰਾਊਜ਼ਰ ਸੈਟਿੰਗਾਂ ਰਾਹੀਂ ਸਾਫ਼ ਕੀਤਾ ਜਾ ਸਕਦਾ ਹੈ, ਜੋ ਕਿਸੇ ਵੀ ਸਥਾਨਕ ਸੰਰਚਨਾ ਨੂੰ ਰੀਸੈਟ ਕਰੇਗਾ।
    `,
    cookie_consent_text: "ਅਸੀਂ ਵੈੱਬਸਾਈਟ ਦੇ ਸਹੀ ਢੰਗ ਨਾਲ ਕੰਮ ਕਰਨ ਨੂੰ ਯਕੀਨੀ ਬਣਾਉਣ ਲਈ ਬੁਨਿਆਦੀ ਕੂਕੀਜ਼ ਦੀ ਵਰਤੋਂ ਕਰਦੇ ਹਾਂ, ਜਿਵੇਂ ਕਿ ਤੁਹਾਡੇ ਸੈਸ਼ਨ ਨੂੰ ਕਿਰਿਆਸ਼ੀਲ ਰੱਖਣਾ, ਤੁਹਾਡੀ ਭਾਸ਼ਾ ਦੀ ਤਰਜੀਹ ਨੂੰ ਸੁਰੱਖਿਅਤ ਕਰਨਾ, ਅਤੇ ਹੋਰ ਕਸਟਮ ਸੰਰਚਨਾਵਾਂ।",
    read_policy: "ਕੂਕੀ ਨੀਤੀ ਪੜ੍ਹੋ",
    support_title: "ਸਹਾਇਤਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
    support_subject_label: "ਵਿਸ਼ਾ",
    support_message_label: "ਸੁਨੇਹਾ",
    support_submit_button: "ਸੁਨੇਹਾ ਭੇਜੋ",
    support_hint: "ਨੋਟ: ਇਹ ਸੁਨੇਹਾ ਭੇਜਣ ਲਈ ਤੁਹਾਡੀ ਡਿਫੌਲਟ ਈਮੇਲ ਐਪਲੀਕੇਸ਼ਨ ਨੂੰ ਖੋਲ੍ਹ ਦੇਵੇਗਾ।",
    support_success_msg: "ਤੁਹਾਡੀ ਈਮੇਲ ਐਪ ਖੋਲ੍ਹੀ ਜਾ ਰਹੀ ਹੈ...",
    support_error_msg: "ਸੁਨੇਹਾ ਭੇਜਣਾ ਅਸਫਲ ਰਿਹਾ। ਕਿਰਪਾ ਕਰਕੇ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
    explorer_title: "ਖੋਜੀ",
    history_title: "ਇਤਿਹਾਸ",
    animation_title: "ਐਨੀਮੇਸ਼ਨ",
    config_title: "ਸੰਰਚਨਾ",
    tool_mouse: "ਚੁਣੋ (Ctrl+M)",
    tool_brush: "ਬੁਰਸ਼ (Ctrl+B)",
    tool_brush_mode: "ਟੌਗਲ ਮੋਡ (ਠੋਸ/ਸਾਫ਼)",
    tool_eraser: "ਇਰੇਜ਼ਰ (Ctrl+E)",
    tool_brush_size: "ਬੁਰਸ਼ ਦਾ ਆਕਾਰ ਵਿਵਸਥਿਤ ਕਰੋ",
    tool_bucket: "ਭਰੋ (Ctrl+F)",
    tool_eyedropper: "ਆਈਡ੍ਰੌਪਰ",
    tool_grid: "ਗਰਿੱਡ (Ctrl+Shift+B)",
    tool_rotate: "ਘੁੰਮਾਓ (Ctrl+Shift+R)",
    tool_flip_h: "ਫਲਿੱਪ H (Ctrl+Shift+H)",
    tool_flip_v: "ਫਲਿੱਪ V (Ctrl+Shift+V)",
    tool_transpose: "ਟ੍ਰਾਂਸਪੋਜ਼ (Ctrl+Shift+T)",
    label_width: "ਚੌੜਾਈ",
    label_height: "ਉਚਾਈ",
    label_frames: "ਫਰੇਮਾਂ ਦੀ ਸੰਖਿਆ",
    label_animation: "ਐਨੀਮੇਸ਼ਨ ਸ਼ੈਲੀ",
    label_background_color: "ਬੈਕਗ੍ਰਾਊਂਡ ਦਾ ਰੰਗ",
    label_interval: "ਅੰਤਰਾਲ",
    tool_anim_config: "ਐਨੀਮੇਸ਼ਨ ਸੰਰਚਨਾ",
    label_new_width: "ਨਵੀਂ ਚੌੜਾਈ",
    label_new_height: "ਨਵੀਂ ਉਚਾਈ",
    label_apply: "ਲਾਗੂ ਕਰੋ",
    label_colors: "ਰੰਗ",
    label_size: "ਆਕਾਰ",
    label_tolerance: "ਸਹਿਣਸ਼ੀਲਤਾ",
    val_horizontal: "ਹਰੀਜੱਟਲ",
    val_vertical: "ਵਰਟੀਕਲ",
    val_sequence: "ਕ੍ਰਮ",
    val_bounce: "ਉਛਾਲ",
    val_random: "ਬੇਤਰਤੀਬ",
    val_solid: "ਠੋਸ",
    val_clear: "ਸਾਫ਼",
    action_add_sheet: "ਨਵੀਂ ਸ਼ੀਟ",
    action_import: "ਆਯਾਤ ਕਰੋ",
    action_export: "ਨਿਰਯਾਤ",
    action_sort_projects: "ਲੜੀਬੱਧ",
    sort_date_old: "ਸਭ ਤੋਂ ਪੁਰਾਣਾ ਪਹਿਲਾ",
    sort_date_new: "ਸਭ ਤੋਂ ਨਵਾਂ ਪਹਿਲਾ",
    sort_name_az: "ਨਾਮ (A-Z)",
    sort_name_za: "ਨਾਮ (Z-A)",
    action_new_sprite: "ਨਵਾਂ ਸਪ੍ਰਾਈਟ",
    action_new_project: "ਨਵਾਂ ਪ੍ਰੋਜੈਕਟ",
    modal_save_all_title: "ਸਾਰੀਆਂ ਤਬਦੀਲੀਆਂ ਨੂੰ ਸੁਰੱਖਿਅਤ ਕਰੋ",
    modal_save_all_desc: "ਬਚਾਉਣ ਲਈ ਸੰਪਤੀਆਂ ਦੀ ਚੋਣ ਕਰੋ:",
    modal_save_selected: "ਸੇਵ ਚੁਣਿਆ",
    action_saved: "ਸੰਭਾਲਿਆ",
    modal_create_sprite_title: "ਨਵਾਂ ਸਪ੍ਰਾਈਟ ਬਣਾਓ",
    modal_create_project_title: "ਨਵਾਂ ਪ੍ਰੋਜੈਕਟ ਬਣਾਓ",
    modal_add_sheet_title: "ਨਵੀਂ ਸ਼ੀਟ ਸ਼ਾਮਲ ਕਰੋ",
    modal_rename_sheet_title: "ਸ਼ੀਟ ਦਾ ਨਾਮ ਬਦਲੋ",
    modal_rename_sprite_title: "ਸਪ੍ਰਾਈਟ ਦਾ ਨਾਮ ਬਦਲੋ",
    modal_delete_sprite_title: "ਸਪ੍ਰਾਈਟ ਮਿਟਾਓ",
    modal_delete_project_title: "ਪ੍ਰੋਜੈਕਟ ਮਿਟਾਓ",
    modal_delete_sheet_title: "ਸ਼ੀਟ ਮਿਟਾਓ",
    placeholder_sprite_name: "ਨਾਮ",
    placeholder_project_name: "ਨਾਮ",
    placeholder_sheet_name: "ਨਾਮ",
    placeholder_new_name: "ਨਵਾਂ ਨਾਮ",
    action_create: "ਬਣਾਓ",
    action_add: "ਸ਼ਾਮਲ ਕਰੋ",
    action_rename: "ਨਾਮ ਬਦਲੋ",
    action_duplicate: "ਡੁਪਲੀਕੇਟ",
    action_delete: "ਮਿਟਾਓ",
    action_cancel: "ਰੱਦ ਕਰੋ",
    confirm_delete_sprite: "ਕੀ ਤੁਸੀਂ ਯਕੀਨੀ ਤੌਰ 'ਤੇ ਇਸ ਸਪ੍ਰਾਈਟ ਨੂੰ ਮਿਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
    confirm_delete_project: "ਕੀ ਤੁਸੀਂ ਯਕੀਨੀ ਤੌਰ 'ਤੇ ਇਸ ਪ੍ਰੋਜੈਕਟ ਨੂੰ ਮਿਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ? ਸਾਰੇ ਸਪ੍ਰਾਈਟਸ ਹਟਾ ਦਿੱਤੇ ਜਾਣਗੇ।",
    confirm_delete_sheet: "ਕੀ ਤੁਸੀਂ ਯਕੀਨੀ ਤੌਰ 'ਤੇ ਇਸ ਸ਼ੀਟ ਨੂੰ ਮਿਟਾਉਣਾ ਚਾਹੁੰਦੇ ਹੋ?",
    err_select_sprite: "ਕਿਰਪਾ ਕਰਕੇ ਪਹਿਲਾਂ ਇੱਕ ਸਪ੍ਰਾਈਟ ਚੁਣੋ।",
    err_select_project: "ਕਿਰਪਾ ਕਰਕੇ ਪਹਿਲਾਂ ਇੱਕ ਪ੍ਰੋਜੈਕਟ ਚੁਣੋ।",
    err_name_empty: "ਨਾਮ ਖਾਲੀ ਨਹੀਂ ਹੋ ਸਕਦਾ।",
    err_sprite_exists: "ਉਸ ਨਾਮ ਨਾਲ ਇੱਕ ਸਪ੍ਰਾਈਟ ਪਹਿਲਾਂ ਹੀ ਮੌਜੂਦ ਹੈ।",
    err_project_exists: "ਇਸ ਨਾਮ ਦਾ ਇੱਕ ਪ੍ਰੋਜੈਕਟ ਪਹਿਲਾਂ ਹੀ ਮੌਜੂਦ ਹੈ।",
    err_no_content: "ਸੁਰੱਖਿਅਤ ਕਰਨ ਲਈ ਕੋਈ ਸਮੱਗਰੀ ਨਹੀਂ ਹੈ।",
    err_no_changes: "ਸੁਰੱਖਿਅਤ ਕਰਨ ਲਈ ਕੋਈ ਬਦਲਾਅ ਨਹੀਂ ਹਨ।",
    err_delete_last_sheet: "ਆਖਰੀ ਸ਼ੀਟ ਨੂੰ ਮਿਟਾਇਆ ਨਹੀਂ ਜਾ ਸਕਦਾ।",
    err_extract_frames: "ਕੋਈ ਫਰੇਮ ਨਹੀਂ ਕੱਢ ਸਕਿਆ।",
    err_indexeddb: "ਸਥਾਨਕ ਤੌਰ 'ਤੇ ਸੁਰੱਖਿਅਤ ਕਰਨ ਵਿੱਚ ਅਸਫਲ। ਹੋ ਸਕਦਾ ਹੈ ਕਿ ਤੁਹਾਡਾ ਬ੍ਰਾਊਜ਼ਰ IndexedDB ਦਾ ਸਮਰਥਨ ਨਾ ਕਰੇ।",
    msg_upload_success: "ਅੱਪਲੋਡ ਸਫਲ: {0}",
    msg_upload_failed: "ਅੱਪਲੋਡ ਅਸਫਲ: {0}",
    msg_save_success: "ਸੁਰੱਖਿਅਤ ਕਰੋ ਸਫਲ।",
    msg_saving: "ਰੱਖਿਅਤ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    msg_multi_save_result: "ਰੱਖਿਅਤ {0} ਸੰਪਤੀਆਂ। {1} ਅਸਫਲਤਾਵਾਂ।",
    menu_title: "ਮੀਨੂ",
    menu_save: "ਸੇਵ ਕਰੋ",
    menu_save_all: "ਸਭ ਨੂੰ ਸੰਭਾਲੋ",
    menu_support: "ਸਹਾਇਤਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ",
    label_local_storage: "ਸਥਾਨਕ ਸਟੋਰੇਜ",
    label_sign_in: "ਸਾਈਨ - ਇਨ",
    modal_export_title: "ਸਪ੍ਰਾਈਟ ਐਕਸਪੋਰਟ ਕਰੋ",
    label_filename: "ਫਾਈਲ ਦਾ ਨਾਮ",
    label_format: "ਫਾਰਮੈਟ",
    action_export_confirm: "ਨਿਰਯਾਤ",
};

export default translations;
